module.exports = __webpack_public_path__ + "1a1bfef2d41763c8c8f3fbbd48b6bfde.png";